import type { KnownContentType } from '@kerberos-compliance/compliance-shared-ts/core/storage/enums/known-content-type.enum';
import { RiskAnalysisKnownContentTypeMap } from '@kerberos-compliance/compliance-shared-ts/core/storage/enums/known-content-type.enum';
import type { DeliveryTrackerStatus } from '@kerberos-compliance/compliance-shared-ts/features/delivery/enums/delivery-tracker-status.enum';
import { DeliveryTrackerStatusMap } from '@kerberos-compliance/compliance-shared-ts/features/delivery/enums/delivery-tracker-status.enum';
import { BytesPerMegabyte, OfficeDocumentExtensions } from '@shared/constants/file-upload.constants';
import type { FileUploadLimits } from '@shared/types/file-upload-limits.type';

export const DeliveryTrackerResultUploadLimits: FileUploadLimits = {
  maxFiles: 10,
  maxFileSize: 50 * BytesPerMegabyte,
  allowedFileExtensions: OfficeDocumentExtensions,
};

export const DeliveryTrackerCloseAndNotifyStatuses: readonly DeliveryTrackerStatus[] = [
  DeliveryTrackerStatusMap.Incomplete,
  DeliveryTrackerStatusMap.Pending,
  DeliveryTrackerStatusMap.Complete,
] as const;

export const DeliveryTrackerNotifyOnlyStatuses: readonly DeliveryTrackerStatus[] = [
  DeliveryTrackerStatusMap.Complete,
] as const;

export const DeliveryTrackerResultContentTypes: readonly KnownContentType[] = Object.values(
  RiskAnalysisKnownContentTypeMap,
);
